package ru.villawonka.app.presentation.model

import ru.villawonka.app.domain.model.PostDomain
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.model.getContactUsername

sealed class PostUIModel {
    abstract val id: Int
    abstract val location: String
    abstract val description: String
    abstract val media: List<String>
    abstract val isLiked: Boolean
    abstract val isNew: Boolean
    abstract val source: PostSourceUIModel?
    abstract val contactUsername: String?
    abstract val contactPhoneNumber: String?
    abstract val createdAt: String

    abstract val similarCount: Int
    abstract val isMain: Boolean
    abstract val hidden: Boolean

    data class Accommodation(
        override val id: Int,
        override val location: String,
        override val description: String,
        override val media: List<String>,
        override val isLiked: Boolean,
        override val isNew: Boolean,
        override val source: PostSourceUIModel?,
        override val contactUsername: String?,
        override val contactPhoneNumber: String?,
        override val createdAt: String,
        override val similarCount: Int,
        override val hidden: Boolean,
        override val isMain: Boolean,

        val displayCost: Int,
        val displayDeposit: Int?,
        val displayCurrency: CurrencyUIModel,
        val conversationDetails: ConversationDetailsUIModel?,

        val rentType: RentTypeUIModel,
        val rentFrom: String?,
        val rentTo: String?,
        val accommodationType: AccommodationTypeUIModel,
        val additions: List<AccommodationAdditionUIModel>,
        val bedrooms: Int?,
        val bathrooms: Int?,

    ) : PostUIModel()
}

fun PostUIModel.groupId(): String = media.first()

fun PostDomain.toUIModel(
    hidden: Boolean = false,
    isMain: Boolean = false,
    similarCount: Int = 0
): PostUIModel = when (this) {
    is PostDomain.Accommodation -> PostUIModel.Accommodation(
        id = id,
        description = description,
        media = media,
        isLiked = isLiked,
        isNew = isNew,
        location = "$city, $district",
        createdAt = createdAt,
        displayCost = displayCost ?: originalCost,
        displayDeposit = displayDeposit ?: originalDeposit,
        displayCurrency = (displayCurrency ?: originalCurrency).toUIModel(),
        conversationDetails = costConversationDetails?.let {
            ConversationDetailsUIModel(
                formula = it.formula,
                originalCost = originalCost,
                originalCurrency = originalCurrency.toUIModel(),
                displayCost = displayCost!!,
                displayCurrency = displayCurrency?.toUIModel()!!,
                exchangeRate = it.exchangeRate,
            )
        },
        rentType = rentType.toUIModel(),
        rentFrom = rentFrom,
        rentTo = rentTo,
        accommodationType = accommodationType.toUIModel(),
        additions = additions?.map { it.toUIModel() } ?: emptyList(),
        bedrooms = bedrooms,
        bathrooms = bathrooms,
        source = source?.toUIModel(),
        contactUsername = getContactUsername(),
        contactPhoneNumber = mentionedPhoneNumbers?.first(),
        similarCount = similarCount,
        hidden = hidden,
        isMain = isMain
    )
    else -> throw NotImplementedError()
}

fun List<PostDomain>.getSimilarPosts(post: PostDomain): List<PostDomain> = this
    .filter { it.media.contains(post.media.first()) }

fun PostUIModel.getPostType() = when (this) {
    is PostUIModel.Accommodation -> PostTypeDomain.ACCOMMODATION
}